import { z } from 'zod';

export const getMWModulesSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    name: z.string(),
    displayName: z.string(),
    requiresVisits: z.boolean(),
    deleted: z.boolean(),
    order: z.number().optional(),
  })
);

export type GetMWModules = z.infer<typeof getMWModulesSchema>;
